module.exports = __webpack_public_path__ + "c3a6b43fca343672d44f8289e713aea6.png";